import { days } from "../../cpcoc/days";
export function monthHead() {
    let html = "";
    for (let i = 0, l = days.length; i < l; i++) {
        html += `<td>${days[i]}</td>`;
    }
    return html;
}
